import { useEffect, useState } from "react";
import FollowTheLine from "./FollowTheLine";

export default function Level3_FollowTheLine(props) {
  const levels = [
    { id: "Level1", label: "Level 1", len: 5},
    { id: "Level2", label: "Level 2", len: 5},
    { id: "Level3", label: "Level 3", len: 5 }
  ];
  
  return (
    <FollowTheLine {...props} levels={levels} />
  );
}

